module.exports = __webpack_public_path__ + "static/media/03_FRMS-2.7-EC-10 1.3925d1f3.svg";